// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Containeirs Injections
import {
  PageWrapper,
  FloatButton,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const OrganizationsListPage = ({
  columns,
  history,
  handleEdit,
  handleDelete,
  organizations,
  setActiveStatus,
}) => {
  return (
    <PageWrapper title={'Organizações'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              columns={columns}
              data={organizations ? organizations : []}
              title="Organizações"
              keysSearch={['name', 'cnpj']}
              titleButton="Nova organização"
              pagination
              persistTableHead
              perPage={10}
              isSearchRemote={false}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
              hasStatusSelect
              handleStatusSelect={(e) => setActiveStatus(e.target.value)}
            />
          </Card>
        </Col>
      </Row>
      <FloatButton handleButton={() => history.push('/organizacoes/novo')} />
    </PageWrapper>
  );
};
